import Route from './route';
import { LazyloadWrapper } from '../../Components/Common';

const Onboarding = LazyloadWrapper(import('./Onboarding'));

export default {
  RenderProp: Onboarding,
  mainRoute: Route,
};
